"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders the Folder icon
 * @param {React.SVGProps<SVGSVGElement>} props - The props for the Folder component
 * @returns {JSX.Element} - The Folder component
 * @example
 * <Folder />
 * @example
 * <Folder height={24} width={24} />
 * @example
 * <Folder className="custom-class" />
 */
function Folder({ isDecorative, ...props }) {
    return (react_1.default.createElement("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "m1 5c0-1.10457.89543-2 2-2h8.1177c.6752 0 1.3049.34077 1.6743.9061l2.208 3.37961-14 3.71429z", fill: "#efb324" }),
        react_1.default.createElement("path", { d: "m3 6.5c-.82843 0-1.5.67157-1.5 1.5v11.5c0 .5523.44771 1 1 1h18.5c.8284 0 1.5-.6716 1.5-1.5v-11c0-.82843-.6716-1.5-1.5-1.5h-7.5106-2.8369z", fill: "#fbefd2", stroke: "#f5d584" }),
        !isDecorative && react_1.default.createElement("title", null, "folder icon")));
}
exports.default = Folder;
